import Axios from 'axios';
import { baseUrl } from '../constants';
let baseURL = baseUrl; //process?.env?.REACT_APP_BASE_URL_SANDBOX || baseUrl; // TODO

const axios = Axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});
export default axios;
